export const legalTerms = (
  <div className="policy-document">
    <section className="policy-intro">
      <h3>Terms of Service for AroundU</h3>
      <p>Last updated: {new Date().toLocaleDateString()}</p>
      <p>Please read these terms carefully before using our services.</p>
    </section>

    <section>
      <h4>1. Acceptance of Terms</h4>
      <p>By accessing or using AroundU's services, you agree to be bound by these terms and conditions. If you disagree with any part of these terms, you may not access our services.</p>
    </section>

    <section>
      <h4>2. Service Provider Obligations</h4>
      <p>Service providers must:</p>
      <ul>
        <li>Provide accurate and up-to-date business information</li>
        <li>Maintain professional standards and quality of service</li>
        <li>Respond to client inquiries promptly</li>
        <li>Comply with all applicable local laws and regulations</li>
        <li>Maintain appropriate licenses and insurance</li>
        <li>Honor appointments and commitments made through the platform</li>
      </ul>
    </section>

    <section>
      <h4>3. User Responsibilities</h4>
      <p>Users of the platform agree to:</p>
      <ul>
        <li>Provide accurate personal information</li>
        <li>Use the service for legitimate purposes only</li>
        <li>Respect the privacy and rights of other users</li>
        <li>Not engage in fraudulent or harmful activities</li>
        <li>Report any violations or suspicious activities</li>
      </ul>
    </section>

    <section>
      <h4>4. Payment Terms</h4>
      <p>Users understand that:</p>
      <ul>
        <li>Service providers set their own rates</li>
        <li>Payment terms are agreed between users and service providers</li>
        <li>AroundU is not responsible for payment disputes</li>
        <li>Platform fees may apply to certain transactions</li>
        <li>All payments must be processed through approved channels</li>
      </ul>
    </section>

    <section>
      <h4>5. Limitation of Liability</h4>
      <p>AroundU is not liable for:</p>
      <ul>
        <li>Quality of services provided by listed businesses</li>
        <li>Disputes between users and service providers</li>
        <li>Loss or damage resulting from use of the platform</li>
        <li>Service interruptions or technical issues</li>
        <li>Third-party actions or content</li>
      </ul>
    </section>
  </div>
); 